/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ProductsAboveAveragePriceRoutingModule
 * Purpose		: Routing module for ProductsAboveAveragePrice.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ProductsAboveAveragePriceListComponent } from './ProductsAboveAveragePriceList.component';
import { ProductsAboveAveragePriceDetailsComponent } from './ProductsAboveAveragePriceDetails.component';

const ProductsAboveAveragePriceRoutes: Routes = [
	{ path: 'ProductsAboveAveragePrice',  component: ProductsAboveAveragePriceListComponent },
	{ path: 'ProductsAboveAveragePrice/Details/:id', component: ProductsAboveAveragePriceDetailsComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(ProductsAboveAveragePriceRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class ProductsAboveAveragePriceRoutingModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/ProductsAboveAveragePrice/ProductsAboveAveragePrice-routing.module.ts